<template>
  <div id="rawMaterialsPage" class="data-list-container">
    <RawMaterialUpdateQueueModal ref="rawMaterialUpdateQueueModal" />
    <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @close="toggleDataSidebar"
      :data="sidebarData"
    />
    <vs-popup
      class="holamundo"
      title="Hammadde Sil"
      :active.sync="deletePopupActive"
      v-esc="escape"
    >
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Hammaddeyi Silmek İstediğinize Eminmisiniz ?</p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button
          type="gradient"
          color="primary"
          @click="
            deletePopupActive = false;
            deletedId = null;
          "
          >Vazgeç</vs-button
        >
        <vs-button
          type="gradient"
          color="danger"
          icon-pack="feather"
          icon="icon-trash"
          @click="deleteData(deletedId)"
        >
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>

    <vs-table
      ref="table"
      :data="rawMaterials"
      :max-items="itemsPerPage"
      v-model="selected"
    >
      <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <global-filter
            ref="filterer"
            :tableOptions="tableOptions"
            :filterOptions="filterOptions"
            :filterChips="filterChips"
            :filterOptionNames="filterOptionNames"
            :isActive="isFilterActive"
            @saveOptions="saveOptions"
            @close="isFilterActive = false"
          />
          <vs-row
            id="panelHeaderRow"
            v-show="!isFilterActive"
            vs-type="flex"
            vs-w="12"
            vs-justify="space-between"
          >
            <vs-col
              id="panel-actions"
              vs-type="flex"
              class="w-auto"
              vs-justify="center"
            >
              <vs-row vs-type="flex" vs-w="12">
                <vs-col v-if="$isCenterBranch() || $isRegionalCenterBranch()" vs-type="flex" class="w-auto">
                  <vx-tooltip text="Yeni Hammadde" position="top">
                    <vs-button
                      @click="addNewData"
                      class="panel-action text-success xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-plus"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Detaylı Filtereleme" position="top">
                    <vs-button
                      @click="isFilterActive = !isFilterActive"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="pickicon"
                      icon="icon-pick-filter"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>


              <vs-col vs-type="flex" class="w-auto">
                <vx-tooltip text="Hammadde Excel Raporu(Kdv ile)" position="top">
                  <vs-button @click="getExcelWithKdv" class="panel-action text-dark xlarge-button panel-action-box-shadow"
                             color="transparent" icon-pack="feather" icon="icon-download">
                  </vs-button>
                </vx-tooltip>
              </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  id="clearFilterButton"
                  v-if="filterChips.length > 0"
                  @click="clearFilter"
                  class="mr-2 bg-white text-danger panel-action-box-shadow"
                  icon-pack="feather"
                  icon="icon-slash"
                  radius
                  color="transparent"
                />
                <vs-col
                  vs-type="flex"
                  class="w-auto"
                  v-for="(chip, index) in filterChips"
                  :key="index"
                >
                  <vs-chip
                    color="white"
                    class="panel-action-box-shadow px-1"
                    @click="removeFilter(chip.col, index)"
                    v-show="chip.value != ''"
                    closable
                  >
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + " :" }}
                        </span>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        class="w-auto ml-1"
                        vs-align="center"
                      >
                        <span
                          class="weight-600 italic text-xsmaller text-primary"
                        >
                          {{ chip.value }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col
              id="table-page-size"
              vs-type="flex"
              class="w-auto"
              vs-justify="flex-end"
            >
              <vs-dropdown
                vs-trigger-click
                class="bg-white cursor-pointer panel-action-box-shadow"
              >
                <div
                  class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
                >
                  <span class="mr-2 page-size-dropdown-span"
                    >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                    -
                    {{
                      totalDataRow - (currentPage + 1) * itemsPerPage > 0
                        ? (currentPage + 1) * itemsPerPage
                        : totalDataRow
                    }}
                    of
                    {{ totalDataRow }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage = 10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 20">
                    <span>20</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th>
          <vs-button
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'rawMaterial.StockCode'
                ? sortingHeadIcon
                : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('rawMaterial.StockCode')"
            >Kodu</vs-button
          >
        </vs-th>
        <vs-th>
          <vs-button
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'RawMaterialCategory.Name'
                ? sortingHeadIcon
                : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('RawMaterialCategory.Name')"
            >Kategori</vs-button
          >
        </vs-th>
        <vs-th>
          <vs-button
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'rawMaterial.Name' ? sortingHeadIcon : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('rawMaterial.Name')"
            >İsim</vs-button
          >
        </vs-th>

        <vs-th>
          <vs-button
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'rawMaterial.Unit' ? sortingHeadIcon : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('rawMaterial.Unit')"
            >Birim</vs-button
          >
        </vs-th>
        <vs-th>
          <vs-button
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'rawMaterial.Supplier.Name'
                ? sortingHeadIcon
                : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('rawMaterial.Supplier.Name')"
            >Tedarikçi</vs-button
          >
        </vs-th>
        <vs-th>
          <vs-button
            color="primary"
            class="opacity-full"
            disabled="true"
            type="flat"
            >Varyantlar</vs-button
          >
        </vs-th>
        <vs-th>
          <vs-button
            color="primary"
            class="opacity-full"
            disabled="true"
            type="flat"
            >Fiyat</vs-button
          >
        </vs-th>
        <vs-th>
          <vs-button
            color="primary"
            class="opacity-full"
            disabled="true"
            type="flat"
            >Kdv</vs-button
          >
        </vs-th>
        <vs-th v-if="$isCenterBranch() || $isRegionalCenterBranch()">
          <vs-button
            color="primary"
            class="opacity-full"
            disabled="true"
            type="flat"
            >İşlem</vs-button
          >
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="font-medium truncate">{{ tr.stockCode }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium truncate">
                {{ tr.rawMaterialCategoryName }}
              </p>
            </vs-td>

            <vs-td>
              <p class="font-medium truncate">{{ tr.name }}</p>
            </vs-td>


            <vs-td>
              <p class="font-medium truncate">{{ tr.unit.name }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium truncate">{{ tr.supplier.name }}</p>
            </vs-td>

            <vs-td>
              <p
                v-if="tr.variants"
                class="font-medium truncate m-auto"
                style="width: fit-content"
              >
                <vs-chip>
                  {{ tr.variants.length }}
                </vs-chip>
              </p>
            </vs-td>
            <vs-td>
              <p class="font-medium truncate">{{ tr.buyPrice }}</p>
            </vs-td>
            <vs-td>
              <p class="font-medium truncate">{{ tr.kdv }}</p>
            </vs-td>
            <vs-td class="whitespace-no-wrap" v-if="$isCenterBranch() || $isRegionalCenterBranch()">
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="
                  deletedId = tr.id;
                  deletePopupActive = true;
                "
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <pagination-default
      :totalLenght="calculatePageLength"
      :setCurrentPage="tableOptions.pageIndex"
      @currentPage="getCurrentPage"
    ></pagination-default>
  </div>
</template>

<script>
import RawMaterialUpdateQueueModal from "./RawMaterialUpdateQueueModal";
import PaginationDefault from "../PaginationDefault";
import GlobalFilter from "../GlobalFilter";
import DataViewSidebar from "./NewRawMaterialAdd.vue";
import moduleRawMaterial from "@/store/rawMaterial/moduleRawMaterial.js";
import { deleteRawMaterial } from "@/api/RawMaterial";
import {
  GetRawMaterialExcel,
  GetRawMaterialExcelWithKdv
} from "@/api/Reports.js";
import {isGranted} from "@/utils/auth";
export default {
  components: {
    DataViewSidebar,
    PaginationDefault,
    GlobalFilter,
    RawMaterialUpdateQueueModal,
  },
  data() {
    return {
      deletedId: null,
      deletePopupActive: false,
      selected: null,

      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,

      tableOptions: {},
      isFilterActive: false,
      filterOptions: [
        "stockCode",
        "rawMaterial",
        "kdv",
        "supplier",
        "supplierOwner",
        "variant",
      ],
      filterOptionNames: [
        "Stok Kodu",
        "Hammadde",
        "Kdv",
        "Tedarikçi",
        "Tedar.Yetkili",
        "Varyant",
      ],
      filterChips: [],

      addNewDataSidebar: false,
      sidebarData: {},
    };
  },
  computed: {
    rawMaterials() {
      return this.$store.state.rawMaterial.rawMaterials;
    },
    totalDataRow() {
      return this.$store.state.rawMaterial.totalDataRow;
    },
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
    isNewRawMaterialPermission(){
      return isGranted("raw_material_write")
    },
    isDeleteRawMaterialPermission(){
      return isGranted("raw_material_delete")
    }
  },
  methods: {

    getExcel() {
      GetRawMaterialExcel(this.tableOptions).then(res => {
        if (res && res.status == 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Hammedde Listesi' + now.getDate() + " " + this.$months()[now.getMonth()]
            .name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
    },
    getExcelWithKdv() {
      GetRawMaterialExcelWithKdv(this.tableOptions).then(res => {
        if (res && res.status == 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Hammedde Listesi' + now.getDate() + " " + this.$months()[now.getMonth()]
            .name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
    },
    openUpdateQueue() {
      this.$refs.rawMaterialUpdateQueueModal.rawMaterialUpdateQueueActive = true;
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "RawMaterialCategory.Name",
        sortDirection: "asc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        stockCode: null,
        rawMaterial: null,
        cost: {
          max: null,
          min: null,
        },
        kdv: null,
        branch: null,
        supplier: null,
        supplierOwner: null,
        variant: null,
        rawMaterialDescription: null,
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    escape() {
      if (this.deletePopupActive == true) {
        this.deletePopupActive = false;
        this.deletedId = null;
      }
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    deleteData(id) {
      deleteRawMaterial(id).then((res) => {
        if (res && res.status == 200) {
          this.$store.dispatch("rawMaterial/removeRawMaterial", id).then(() => {
            this.deletePopupActive = false;
            this.$vs.notify({
              color: "success",
              title: "Silme İşlemi",
              text: "Hammadde Başarıyla Silindi",
            });
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Silme İşlemi Başarısız !",
          });
        }
      }).catch((error) => {
        this.deletePopupActive = false;
        let errMsg = "Silme İşlemi Başarısız !";
        if (error.response && error.response.data && error.response.data.Errors && error.response.data.Errors.length > 0) {
          errMsg = error.response.data.Errors[0].Message;
        }
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: errMsg,
        });
      });
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      val == false ? (this.selected = "") : null;
    },
    getRawMaterialList() {
      this.$store
        .dispatch(
          "rawMaterial/fetchDataListItemsRawMaterial",
          this.tableOptions
        )
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error,
          });
        });
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    },
  },
  created() {
    if (!moduleRawMaterial.isRegistered) {
      this.$store.registerModule("rawMaterial", moduleRawMaterial);
      moduleRawMaterial.isRegistered = true;
    }
    document.body.addEventListener("keyup", (e) => {
      if (e.keyCode === 13) {
        if (this.deletePopupActive) this.deleteData(this.deletedId);
      }
    });
    this.clearFilter();
    if (!this.$isCenterBranch() && !this.$isRegionalCenterBranch()) {
      let branchPropIndex = this.filterOptions.indexOf("branch");
      this.filterOptions.splice(branchPropIndex, 1);
      this.filterOptionNames.splice(branchPropIndex, 1);

      delete this.tableOptions["branch"];
    }
  },
  watch: {
    selected: function (val) {
      if (val != "" && (this.$isCenterBranch() ||this.$isRegionalCenterBranch())) {
        if (val.type != "HalfMade") this.editData(val);
        else {
          this.$vs.notify({
            color: "danger",
            title: "Seçilen Ürün Bir Yarımamül !",
            text: "Ürünü Güncellemek için Yarımamül Sayfasına Gidin",
          });
          this.selected = "";
        }
      }
    },
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    },
    tableOptions: {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          this.getRawMaterialList();
        });
      },
    },
  },
};
</script>

<style></style>
